import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DIA_SEMANA_LABELS, DIAS_SEMANA, DiaSemana } from '../../model/horario-funcionamento/horario-funcionamento.model';

@Component({
  selector: 'app-dias-semana',
  standalone: true,
  templateUrl: './dias-semana.component.html',
  styleUrl: './dias-semana.component.css',
})
export class DiasSemanaComponent {
  @Input() diasSelecionados: DiaSemana[] = [];
  @Input() diasDisponiveis: DiaSemana[] = DIAS_SEMANA;
  @Input() disabled = false;
  @Output() diasSelecionadosChange = new EventEmitter<DiaSemana[]>();

  readonly labels = DIA_SEMANA_LABELS;

  alternarDia(dia: DiaSemana): void {
    if (this.disabled) {
      return;
    }

    const selecionados = this.diasSelecionados.includes(dia)
      ? this.diasSelecionados.filter((item) => item !== dia)
      : [...this.diasSelecionados, dia].sort((a, b) => a - b);

    this.diasSelecionados = selecionados;
    this.diasSelecionadosChange.emit([...selecionados]);
  }

  estaSelecionado(dia: DiaSemana): boolean {
    return this.diasSelecionados.includes(dia);
  }
}
